import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FavoriteButtonWrapperContainer } from '@cian/favorites-assign-widget';
import { TooltipDesktop } from '@cian/ui-kit';

import { addToFavorite, deleteFromFavorite } from '../../actions/favorites';
import { FavoriteButtonColored } from '../../components/FavoriteButtonColored';
import { selectIsAuthenticated } from '../../selectors/user';
import { TThunkDispatch } from '../../types/redux/thunk';
import { PromoOfferCardContext } from '../../utils/promoOfferCardContext';

export function FavoritesButtonContainer() {
  const dispatch: TThunkDispatch = useDispatch();
  const isAuthenticated = useSelector(selectIsAuthenticated);
  const { offerId, isFavorite } = React.useContext(PromoOfferCardContext);

  const handleClick = React.useCallback(
    (event: React.MouseEvent<HTMLButtonElement>) => {
      event.stopPropagation();
      event.preventDefault();

      if (isAuthenticated) {
        const action = isFavorite ? deleteFromFavorite : addToFavorite;
        dispatch(action(offerId));
      } else {
        if (window.waitForLoginPopup) {
          window.waitForLoginPopup('favorites');
        }
      }
    },
    [dispatch, isFavorite, offerId, isAuthenticated],
  );

  const handleLogin = React.useCallback(() => {
    if (window.waitForLoginPopup) {
      window.waitForLoginPopup('favorites');
    }
  }, []);

  return (
    <FavoriteButtonWrapperContainer
      offerId={offerId}
      placement="bottom-end"
      isAuthenticated={isAuthenticated}
      onWaitForLogin={handleLogin}
    >
      <TooltipDesktop theme="black" placement="left" title={isFavorite ? 'В избранном' : 'Добавить в избранное'}>
        <FavoriteButtonColored onClick={handleClick} isFavorite={isFavorite} />
      </TooltipDesktop>
    </FavoriteButtonWrapperContainer>
  );
}
